// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  height: 100%;
}

ion-card {
  width: 100%;
  height: 100%;
  margin: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.save-button {
  opacity: 1;
  position: absolute;
  z-index: 990;
  width: 150px;
  height: 40px;
  right: var(--spacing-small);
  border-radius: var(--af-radius-section);
  background-color: var(--ion-color-primary);
  border: 2px solid transparent !important;
  margin-left: auto;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}
.save-button ion-icon,
.save-button ion-label {
  color: white !important;
}
.save-button:hover {
  border: 2px solid var(--ion-color-primary) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  color: var(--ion-color-primary);
  background-color: white;
}
.save-button:hover ion-icon,
.save-button:hover ion-label {
  color: var(--ion-color-primary) !important;
}
.save-button:active {
  transform: scale(0.98);
}

ion-select::part(icon) {
  color: white;
  margin-left: var(--spacing-small);
  width: var(--icon-size-small);
  height: var(--icon-size-small);
}

.popover-style {
  --width: auto;
}

ion-textarea.notesTextarea {
  width: 100%;
  height: 100%;
  max-height: 150px;
  font-size: var(--font-size-small);
}
ion-textarea.notesTextarea ::ng-deep .label-text-wrapper.sc-ion-textarea-md .label-text.sc-ion-textarea-md {
  opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/logbooks/components/log-summaries/maintenance-form/maintenance-form.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,UAAA;EACA,kBAAA;EACA,YAAA;EAEA,YAAA;EACA,YAAA;EAEA,2BAAA;EAEA,uCAAA;EACA,0CAAA;EACA,wCAAA;EAEA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAHJ;AAKI;;EAEI,uBAAA;AAHR;AAMI;EACI,qDAAA;EACA,0CAAA;EACA,+BAAA;EACA,uBAAA;AAJR;AAMQ;;EAEI,0CAAA;AAJZ;AAQI;EACI,sBAAA;AANR;;AAUA;EACI,YAAA;EACA,iCAAA;EACA,6BAAA;EACA,8BAAA;AAPJ;;AAUA;EACI,aAAA;AAPJ;;AAUA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iCAAA;AAPJ;AAUQ;EACI,YAAA;AARZ","sourcesContent":[":host {\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\nion-card {\r\n    width: 100%;\r\n    height: 100%;\r\n    margin: 0;\r\n    overflow: hidden;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.save-button {\r\n    opacity: 1;\r\n    position: absolute;\r\n    z-index: 990;\r\n\r\n    width: 150px;\r\n    height: 40px;\r\n\r\n    right: var(--spacing-small);\r\n\r\n    border-radius: var(--af-radius-section);\r\n    background-color: var(--ion-color-primary);\r\n    border: 2px solid transparent !important;\r\n\r\n    margin-left: auto;\r\n    transition: all 0.3s ease;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: white;\r\n\r\n    ion-icon,\r\n    ion-label {\r\n        color: white !important;\r\n    }\r\n\r\n    &:hover {\r\n        border: 2px solid var(--ion-color-primary) !important;\r\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n        color: var(--ion-color-primary);\r\n        background-color: white;\r\n\r\n        ion-icon,\r\n        ion-label {\r\n            color: var(--ion-color-primary) !important;\r\n        }\r\n    }\r\n\r\n    &:active {\r\n        transform: scale(0.98);\r\n    }\r\n}\r\n\r\nion-select::part(icon) {\r\n    color: white;\r\n    margin-left: var(--spacing-small);\r\n    width: var(--icon-size-small);\r\n    height: var(--icon-size-small);\r\n}\r\n\r\n.popover-style {\r\n    --width: auto;\r\n}\r\n\r\nion-textarea.notesTextarea {\r\n    width: 100%;\r\n    height: 100%;\r\n    max-height: 150px;\r\n    font-size: var(--font-size-small);\r\n\r\n    ::ng-deep .label-text-wrapper.sc-ion-textarea-md {\r\n        .label-text.sc-ion-textarea-md {\r\n            opacity: 0.7;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
